<template>
    <div class="atelier-container">
        <!-- Banner -->
        <CommonComponentsProductsAtelierSwipper />
        <div class="global-limited-1360px-container">
            <!-- <CommonComponentsProductsAtelierSwipper /> -->
            <!-- 1 -->
            <CommonComponentsProductsAtelierContent />
            <!-- 2 -->
            <CommonComponentsProductsAtelierExhibit />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { onMounted } from 'vue';
    onMounted(() => {
        addTextScrollLine('.atelier-text-scroll');
        addSlideInUp('.atelier-text-slide');
    });
</script>

<style lang="less" scoped>
    .atelier-container {
        background-color: #000000;
        width: 100%;
        color: #fff;
        overflow: hidden;
    }
</style>
